import React from "react";

import {Helmet} from "react-helmet-async";

import {useProject} from "../../contexts/ProjectContext";

const PREFIX = "WB";

export const PageTitle = ({title, suffix}) => {
	const {info} = useProject();
	const parts = [PREFIX];

	if (title) parts.push(title);
	if (info.project_name) parts.push(info.project_name);
	if (suffix) parts.push(suffix);

	const fullTitle = parts.join(" ");

	return (
		<Helmet>
			<title>{fullTitle}</title>
		</Helmet>
	);
};
